import { Component, OnInit, Input, Inject } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-dni-validation-digit',
  templateUrl: './dni-validation-digit.component.html',
  styleUrls: ['./dni-validation-digit.component.scss']
})
export class DniValidationDigitComponent implements OnInit {
  @Input() clientCode: string;
  dni: string;
  constructor(private accountService: AccountService,
    private matDialogRef: MatDialogRef<DniValidationDigitComponent>,
    @Inject(MAT_DIALOG_DATA) private input: any) { }

  ngOnInit() {
    this.clientCode = this.input.clientCode;
  }
  validateDni() {
    this.accountService.getBasicData(this.clientCode).subscribe(response => {
      if (response.valid && response.data.documentNumber == this.dni) {
        this.close(true);
      }
    })
  }
  close(proceed: boolean) {
    this.matDialogRef.close(proceed);
  }
}
